//Include Both Helper File with needed methods

import { postLogOut } from "../../../helpers/fakebackend_helper";

import {} from "./reducer";

import { createAsyncThunk } from "@reduxjs/toolkit";

export const logoutThunk = createAsyncThunk(
  "logoutThunk",
  async ({ token }) => {
    try {
      const response = postLogOut(token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
